import { Component } from '@angular/core';
import { SocietyTypeEnum } from '../Enums/enums';
import { CommonService } from '../services/common.service';
import { ToastService } from '../toast/toast.service';
import { Page } from '../classes/page';

@Component({
  selector: 'app-cooperative-societies',
  templateUrl: './cooperative-societies.component.html',
  styleUrls: ['./cooperative-societies.component.scss']
})
export class CooperativeSocietiesComponent {
  listName: string='';
  dateVariable = new Date();
  societyTypeList: any[] = [];
  selectedSocietyType: any;
  errorMessage: string='';
  societyList: any[]=[];
  rows: any[] = [];
  page = new Page();
  columns: any[] = [];
  loading = false;
  isSocietyData:boolean=false;
  constructor(private commonService:CommonService,
      private toastService: ToastService) {
        this.page.pageNumber = 0;
    this.page.pageSize = 10;
    this.setPage({ offset: 0 });
      }

  ngOnInit(): void {
    this.listName = 'My Sample List';
    this.dateVariable = new Date();
    this.getMasterData('SocietyType', SocietyTypeEnum.SocietyType);     // 3
    this.setColumns();
  }
  setPage(pageInfo: any) {
  }
  setColumns(){
    this.columns = [

      { prop: 'sSocietyNameAddr', name: '	Name and Address of Society' },
      { prop: 'sPincode', name: 'Pin Code' },
      { prop: 'sSocietyRegistrationNo', name: 'Reg No./Date' },
      { prop: 'CircleBlockName', name: 'Circle/Block' },
      { prop: 'SecretaryNamePh', name: 'Secretary Name/Ph.' },
      { prop: 'MCMemberNamePh', name: 'MC Member Name/Ph.' },
      { prop: 'EmailId', name: 'Email Id' },
      { prop: 'WhetherSocietyhasComputer', name: 'Whether Society has Computer' },
      { prop: 'WhetherSocietyhasLand', name: 'Whether Society has Land' },
      { prop: 'WhetherSocietyinProfitLoss', name: 'Whether Society in Profit/ Loss' },
    ];
  }
  getReport(): void {
    if (!this.selectedSocietyType) {
      this.toastService.showError('Please select a Society Type');
      return;
    }
    const selectedSociety = this.societyTypeList.find(
      x => x.id === +this.selectedSocietyType
    );
    this.listName = 'List of '+ selectedSociety.name;
    this.isSocietyData = true;
    this.commonService.getCooperativeSocieties(this.selectedSocietyType).subscribe((response) =>{
      if (response.status === 200) {
        this.rows = response.data;
        this.page.totalRecords = response.totalRecords;
      } else {
        this.rows = [];
        this.page.totalRecords = 0;
        this.toastService.showError(response.message);
      }
    },
    (error) => {
      this.rows = [];
        this.page.totalRecords = 0;
      // Handle any errors that occur during the request
      this.errorMessage = 'Error fetching society details: ' + error.message;
      console.error('Error fetching society details:', error);
    });
  }
  getMasterData(action: string, id: number): void {
    if (!action || id === undefined || id === null) {
      console.error('Invalid parameters for GetMasterData:', action, id);
      return;
    }
    this.commonService.GetMasterData(action, id).subscribe(
      (response) => {
        if (response.status === 200) {
          this.societyTypeList = response.data;
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }
  back(){
    this.selectedSocietyType = '';
    this.getMasterData('SocietyType', SocietyTypeEnum.SocietyType);
    this.rows = [];
    this.isSocietyData = false;
  }
}
